import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "my-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("h1", null, "Logos", -1)
            ])),
            _: 1,
            __: [0]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "my-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Logomark: White", -1)),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logomark-white_bg-transparent.png",
                class: "pr-12 mt-12"
              }),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logomark-black_bg-transparent.svg",
                class: "pr-12 mt-12"
              })
            ]),
            _: 1,
            __: [1]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "my-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Logomark: Gray, Black", -1)),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logomark-gray_bg-transparent.png",
                class: "pr-12 mt-12"
              }),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logomark-black_bg-white.png",
                class: "pr-12 mt-12"
              }),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logomark-black_bg-transparent.png",
                class: "pr-12 mt-12"
              })
            ]),
            _: 1,
            __: [2]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "my-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Logotype, Logo: Gray", -1)),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logotype-gray_bg-transparent.png",
                class: "pr-12 mt-12"
              }),
              _createVNode(_component_LogoComponent, {
                src: "/img/logo/andromeda_logo-gray_bg-transparent.png",
                class: "pr-12 mt-12"
              })
            ]),
            _: 1,
            __: [3]
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}